/* eslint-disable @typescript-eslint/camelcase */
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { Component, Vue, Watch } from 'vue-property-decorator'
import AppForm from '@core/components/AppFormV2.vue'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppModal from '@core/components/AppModalV2.vue'
import AppKBColHeader from '@core/components/kanban/AppKBColHeader.vue'
import AppKBColCardList from '@core/components/kanban/AppKBColCardList.vue'
import { IDateService } from '@master/services/IDateService'
import { KBCardStructure } from '@core/model/structure/KBStructure'
import AdminIcon from '@core/components/header/assets/admin.svg'
import addIcon from '@core/components/kanban/assets/plus.png'
import { FormStructure } from '@master/model/structure/FormStructure'
import { CreateRecruitDetail } from '@core/model/recruit/CreateRecruitDetail'
import { AccountService, PicodedAccountDTO } from './api'
import { AccountStructureService } from '@core/pages/sales-team-administration/api'
@Component({
  components: {
    AppForm,
    AppDatatable,
    AppModal,
    AppKBColHeader,
    AppKBColCardList
  }
})
export class HomeRecruiterMixin extends Vue {
  @inject()
  protected dateService: IDateService

  @inject()
  protected $api: API

  protected recruitIcon = AdminIcon
  protected addIcon = addIcon
  protected recruitForm = false
  protected recruitInfo = new CreateRecruitDetail()
  protected pending: KBCardStructure[] = []
  protected processing: KBCardStructure[] = []
  protected recruited: KBCardStructure[] = []
  protected supervisorList: Array<PicodedAccountDTO> = []

  get isDirector () {
    return this.currentUser?.systemrole === 'director'
  }

  get recruitInfoStructure (): FormStructure<CreateRecruitDetail> {
    if (this.isDirector) {
      return [
        // { label: 'User Name', key: 'userName' },
        { label: 'Name (as per NRIC)', key: 'recruitName' },
        { label: 'NRIC', key: 'idNumber' },
        { label: 'Email Address', key: 'userEmail' },
        {
          label: 'Financial Service Manager',
          key: 'supervisorOid',
          options: this.supervisorList.map(supervisor => ({ label: supervisor.fullname, value: supervisor.oid }))
        }
      ]
    }

    return [
      // { label: 'User Name', key: 'userName' },
      { label: 'Name (as per NRIC)', key: 'recruitName' },
      { label: 'NRIC', key: 'idNumber' },
      { label: 'Email Address', key: 'userEmail' },
      {
        label: 'Financial Service Manager',
        key: 'financialServiceManager',
        show: this.currentUser.systemrole === 'director'
      }
    ]
  }

  protected cards: KBCardStructure[] = []

  get currentUser () {
    return this.$store.getters.currentUser
  }

  showRecruitForm () {
    this.recruitInfo.userEmail = ''
    this.recruitInfo.recruitName = ''
    this.recruitInfo.idNumber = ''
    this.recruitForm = true
  }

  async getRecruit () {
    if (this.currentUser && this.currentUser.isSuperUser) {
      return await this.getAllRecruit()
    }

    if (this.currentUser) {
      const res = await this.$api.recruit.detail.search({ recruiterOid: this.currentUser._oid })
      this.pending = []
      this.processing = []
      this.recruited = []
      this.organizeCards(res)
    }
  }

  async getAllRecruit () {
    const res = await this.$api.recruit.detail.findAll({ recruiterOid: this.currentUser._oid })
    this.pending = []
    this.processing = []
    this.recruited = []
    this.organizeCards(res)
  }

  organizeCards (recruits: any[]) {
    recruits.forEach((rec) => {
      const recCard: KBCardStructure = {
        name: `${rec.account?.fullname} (${rec.account?.username})`,
        accountOid: rec?.accountOid
      }
      switch (rec.status) {
        case 'PENDING':
          this.pending.unshift(recCard)
          break
        case 'PROCESSING':
          this.processing.unshift(recCard)
          break
        case 'RECRUITED':
          this.recruited.unshift(recCard)
          break
      }
    })
  }

  async createRecruit () {
    if (!this.recruitInfo.recruiterOid || !this.recruitInfo.recruiterOid.length) {
      return alert('Missing recruiter information !')
    }

    await this.$api.recruit.detail.create(this.recruitInfo)
    this.recruitForm = false
    await this.getRecruit()
  }

  @Watch('currentUser')
  updateRecruiterOid () {
    this.recruitInfo.recruiterOid = this.currentUser?._oid
  }

  async atCreateModalOpen () {
    this.supervisorList = await AccountService.getDirectorSupervisorList(this.currentUser._oid)
    this.recruitInfo.supervisorOid = this.currentUser._oid
  }

  async getStructures () {
    const res = await AccountStructureService.getStructureDetails(3)
    console.log(res)
  }

  async created () {
    await this.getRecruit()
    // this.getStructures()
  }

  async mounted () {
    if (this.currentUser) {
      this.recruitInfo.recruiterOid = this.currentUser?._oid
    }
  }

  visitRecruitActivity (recruit) {
    if (recruit.accountOid) {
      this.$router.push({ name: 'recruit', params: { recruitAccountOid: recruit.accountOid } })
    }
  }
}
